import { captureException } from "@sentry/browser";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { showNotification } from "../../notification/actions";
import { CHANGE_PLAN_COPY } from "../types";
import { IStateTree } from "../../interfaces";
import { PlanActionTypes } from "../models/planActions";

export default (data: { planId: string, copyright: boolean }, callback: () => void) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        await api.post<{ success: boolean }>("/change-plan-copy", data);
        dispatch({
            type: CHANGE_PLAN_COPY,
            payload: data,
        });
        callback();
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
